import { Helmet } from "react-helmet-async";

const BASE = "https://terbeck-service.de";

export const Seo = ({ title, description, path = "/", jsonLd }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href={`${BASE}${path}`} />
    {jsonLd && (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    )}
  </Helmet>
);
